module.exports = __webpack_public_path__ + "static/media/trash_icon.1006e654.svg";